export const testcasesTypes = {
  GET_TESTCASES: "GET_TESTCASES",
  GET_TESTCASES_COMMIT: "GET_TESTCASES_COMMIT",
  GET_TESTCASES_ROLLBACK: "GET_TESTCASES_ROLLBACK",
};
